var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'info-alert': true,
    'info-alert--border': _vm.border,
    'info-alert--danger': _vm.type === 'danger',
}},[_c('img',{attrs:{"src":require("@/assets/images/icons/info-icon-blue.svg"),"alt":""}}),_vm._v(" "),(_vm.isHtml)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]:[_c('span',[_vm._v(_vm._s(_vm.text))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }